import React from "react";
import PropTypes from "prop-types";

function Divider({ mb = "mb-20p", mt = "", mx = "mx-20p ", className }) {
    return <hr className={mb + " " + mt + " " + mx + className} />;
}

Divider.propTypes = {
    mb: PropTypes.string,
    mt: PropTypes.string,
    mx: PropTypes.string,
    className: PropTypes.string,
}

export default Divider;
